import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import InputField from '../../../../components/InputField';
import { useGetRolesQuery } from '../../../../store/apiSlices/recruitApiSlice';
import { DropdownModel } from '../../../../models/dropdown.model';
import { OfficerRoles } from '../../../../enums/enum';
import { RootState } from '../../../../store/store';

const Production = () => {
	const addOrUpdateRecruit = useSelector(
		(state: RootState) => state.addOrUpdateRecruit,
	);
	const { getFieldProps, getFieldMeta, getFieldHelpers } = useFormikContext();
	const rolesMasterData = useGetRolesQuery(null);
	const [roles, setRoles] = useState<DropdownModel[]>([]);

	useEffect(() => {
		if (!rolesMasterData.currentData?.value?.length) return;
		const roles = rolesMasterData.currentData.value;
		setRoles(roles);
	}, [rolesMasterData]);

	const isLoanOfficer = () => {
		return (
			getFieldProps('general_details.role_id').value ===
			roles?.find((e) => e.value === OfficerRoles.loanOfficer)?.id
		);
	};

	const isBranch = () => {
		return (
			getFieldProps('general_details.role_id').value ===
			roles?.find((e) => e.value === OfficerRoles.branch)?.id
		);
	};

	return (
		<>
			<div className="flex flex-col bg-white p-4 gap-y-4 rounded-lg">
				{isBranch() ? (
					<div className="flex flex-col">
						<div className="text-xl font-bold">
							Total Branch Production
						</div>
						<small>
							Please enter production for the whole branch, not
							just the manager.
						</small>
					</div>
				) : (
					<div className="text-xl font-bold">Production</div>
				)}
				<div
					className={`grid gap-4 ${addOrUpdateRecruit.isUpdatingRecruit && isLoanOfficer() ? 'grid-cols-1' : 'grid-cols-2'}`}
				>
					<>
						<InputField
							name="production_details.monthly_units"
							labelClassName={`${isLoanOfficer() ? 'col-span-*' : 'col-span-'}`}
							min={0}
							type="number"
							isNullable={true}
							label="Monthly Units"
							placeholder="Enter Monthly Units"
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
						/>

						<InputField
							name="production_details.monthly_volume"
							label="Monthly Volume"
							currency={true}
							isNullable={true}
							placeholder="Enter Monthly Volume"
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
						/>
					</>
					{addOrUpdateRecruit.isUpdatingRecruit ? (
						<>
							{/* <InputField
								name="production_details.annual_units"
								isRequired={false}
								type="number"
								min={0}
								label="Annual Units"
								placeholder="Enter Annual Units"
								disabled={
									addOrUpdateRecruit.isRecruitFieldsDisabled
								}
							/>

							<InputField
								name="production_details.annual_volume"
								label="Annual Volume"
								isRequired={false}
								currency={true}
								placeholder="Enter Annual Volume"
								disabled={
									addOrUpdateRecruit.isRecruitFieldsDisabled
								}
							/> */}
							<InputField
								name="production_details.conventional_loans"
								type="number"
								isRequired={false}
								min={0}
								max={100}
								label="% Conv"
								placeholder="Enter Conv%"
								disabled={
									addOrUpdateRecruit.isRecruitFieldsDisabled
								}
							/>

							<InputField
								name="production_details.bonds"
								type="number"
								label="% Bond"
								min={0}
								max={100}
								isRequired={false}
								placeholder="Enter Bond%"
								disabled={
									addOrUpdateRecruit.isRecruitFieldsDisabled
								}
							/>
							<InputField
								name="production_details.government_loans"
								type="number"
								min={0}
								max={100}
								label="% Govt"
								isRequired={false}
								placeholder="Enter Govt%"
								disabled={
									addOrUpdateRecruit.isRecruitFieldsDisabled
								}
							/>
							<InputField
								name="production_details.broker"
								type="number"
								min={0}
								max={100}
								label="% Broker/NQM"
								isRequired={false}
								placeholder="Enter Broker%"
								disabled={
									addOrUpdateRecruit.isRecruitFieldsDisabled
								}
							/>
							<InputField
								name="production_details.jumbo"
								type="number"
								min={0}
								max={100}
								label="% Jumbo"
								isRequired={false}
								placeholder="Enter Jumbo%"
								disabled={
									addOrUpdateRecruit.isRecruitFieldsDisabled
								}
							/>
						</>
					) : null}
				</div>
			</div>
		</>
	);
};
export default Production;
